module.exports = __webpack_public_path__ + "media/src/images/top_covers/giftee_haloween02-fa55e5cb63d949f8fff4364087e7bc03.png";